import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WarningIcon } from 'foundations-assets';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export function getStatusMessage(isAwayMode) {
  // using I18n.text because this is for `aria-label` which can't take an Element
  if (isAwayMode) {
    return I18n.text('routing-ui.agent-status.agentIsAway');
  } else {
    return I18n.text('routing-ui.agent-status.agentIsAvailable');
  }
}
const AvailabilityIndicatorDot = ({
  isAwayMode
}) => /*#__PURE__*/_jsx(StatusDot, {
  "aria-label": getStatusMessage(isAwayMode),
  "data-test-id": "agent-status-available-indicator",
  role: "img",
  use: isAwayMode ? 'default' : 'success'
});
AvailabilityIndicatorDot.displayName = 'AvailabilityIndicatorDot';
const OverCapacityIndicator = () => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.agent-status.maxCapacityTooltip"
  }),
  children: /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineEnd: "200",
    children: /*#__PURE__*/_jsx(WarningIcon, {
      color: "fill-accent-yellow-default",
      "data-test-id": "agent-status-at-capacity-indicator"
    })
  })
});
OverCapacityIndicator.displayName = 'OverCapacityIndicator';
const AvailabilityIndicator = ({
  isAwayMode,
  atCapacity
}) => {
  return atCapacity ? /*#__PURE__*/_jsx(OverCapacityIndicator, {}) : /*#__PURE__*/_jsx(AvailabilityIndicatorDot, {
    isAwayMode: isAwayMode
  });
};
AvailabilityIndicator.displayName = 'AvailabilityIndicator';
export default AvailabilityIndicator;